import * as React from "react";
import { WizardLXPWAProps } from "./typings";
import { Location } from "src/components/shared/Location/Location";
import { observer, MobXProviderContext } from "mobx-react";
import { LobTitle } from "src/components/shared/LobTitle/LobTitle";
import { SubmitRow } from "src/components/shared/StorefrontWizard/SubmitRow/SubmitRow";
import { Dates } from "src/components/shared/Dates/Dates";
import { ClientWizardStateStore } from "stores/wizard/ClientWizardStateStore";
import { LobSubtitleWithLink } from "src/components/shared/LobSubtitle/LobSubtitleWithLink";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";
import { LobSubtitle } from "src/components/shared/LobSubtitle/LobSubtitle";

export const WizardLXPWAView: React.FunctionComponent<WizardLXPWAProps> = observer(({ flexComponent }) => {
  const wizardState: ClientWizardStateStore = React.useContext(MobXProviderContext).wizardState;
  const {
    lxWizardState,
    lxWizardState: { config: lxConfig },
    lxWizardState: {
      config: { heading },
    },
  } = wizardState;

  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 12 };
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 7 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 5 };

  const { visibleLobSubtitle, locSubtitleTextToken, locSubtitleLinkToken, locSubtitleLinkUrl } = heading;

  const setInputsRefs = (ref: React.RefObject<HTMLInputElement>, secondRef?: React.RefObject<HTMLInputElement>) => {
    lxWizardState.wizardInputsArray.push(ref);
    if (secondRef) {
      lxWizardState.wizardInputsArray.push(secondRef);
    }
  };

  const getLocError = (isLink: boolean) => {
    if (!isLink) {
      return lxWizardState.moreThanOneError()
        ? lxConfig.form.submitButton.locMultipleWarningsToken
        : lxConfig.form.submitButton.locWarningToken;
    }

    return lxWizardState.moreThanOneError()
      ? lxConfig.form.submitButton.locMultipleWarningsLinkToken
      : lxConfig.form.submitButton.locWarningLinkToken;
  };

  return (
    <form
      noValidate={true}
      action={lxConfig.form.action}
      autoComplete="off"
      className="WizardLXPWA"
      id={lxConfig.elementId}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
      data-testid="wizard"
      onSubmit={lxWizardState.submit}
    >
      <LobTitle lobState={lxWizardState} />
      <LobSubtitle lobState={lxWizardState} />
      {visibleLobSubtitle && (
        <LobSubtitleWithLink
          locKey={locSubtitleTextToken!}
          locLinkKey={locSubtitleLinkToken!}
          linkUrl={locSubtitleLinkUrl!}
          className="all-b-padding-four all-t-margin-one"
        />
      )}
      <UitkLayoutGrid columns={mainGridColumns} space="three" className="all-t-margin-three">
        <>
          {lxWizardState.numberOfErrors > 0 && (
            <LobErrorSummary
              locHeadingToken={getLocError(false)!}
              locHeadingArgs={lxWizardState.moreThanOneError() && [lxWizardState.numberOfErrors]}
              locLinkToken={getLocError(true)}
              linkClickFocusId="id-roundtrip-error"
              inputErrorRef={lxWizardState.errorInputRef}
              colSpan={mainGridColumns}
              setInputsRefs={setInputsRefs}
            />
          )}
          <Location
            setInputsRefs={setInputsRefs}
            originField={false}
            destinationField={true}
            lobState={lxWizardState}
            colSpan={locationColSpan}
          />
          <Dates
            lobState={lxWizardState}
            colSpan={datesColSpan}
            singleDateSelect={true}
            setInputsRefs={setInputsRefs}
          />
        </>
      </UitkLayoutGrid>

      <SubmitRow lobState={lxWizardState} rfrr={"SearchClick_LX"} />
    </form>
  );
});

export default WizardLXPWAView;
